<template>
    <div class="w3-col w3-left-align">
    <ContentHeader v-bind:title="$t('visitor-amount-report')" />
  </div>
  <ReportItem
    :columns="pdfColumns"
    :objects="visitorAmount"
    :file-name="$t('visitor-amount-report_')"
    :start-day="$helper.lastMonth()"
    :end-day="$helper.today()"
    @emittedDays="onDateUpdate"
  >
    <StandardTable
      :sort-options="true"
      :no-content="'noData'"
      :column-definitions="columnDefinitions"
      :records="visitorAmountAsList"
    />
  </ReportItem>
</template>

<script>
import StandardTable from "../../common/StandardTable.vue";
import ReportItem from "./ReportItem.vue";
import ContentHeader from "../../common/ContentHeader.vue";

export default {
  name: "AmountOfVisitors",
  components: { StandardTable, ReportItem, ContentHeader },
  mounted() {
    const days = [this.$helper.lastMonth(), this.$helper.today()];
    this.onDateUpdate(days);
  },
  computed: {
    visitorAmountAsList() {
        return this.visitorAmount.map(a => ({
            nrOfVisitors: a.nrOfVisitors,
            site: a.site
        }));
    }
  },
  data() {
    return {
      columnDefinitions: [
        { key: "site", label: this.$t("site"), dataKey: "site" },
        { key: "amount_of_visitors", label: this.$t("amount_of_visitors"), dataKey: "nrOfVisitors" }
      ],
      visitorAmount: [],
      pdfColumns: [
        { title: this.$t("site"), dataKey: "site" },
        { title: this.$t("amount_of_visitors"), dataKey: "nrOfVisitors" }
      ]
    };
  },
  methods: {
    onDateUpdate(days) {
      const queryString = `startDate=${this.$helper.flipDateFormat(days[0])}&endDate=${this.$helper.flipDateFormat(days[1])}`;
      this.fetchVisitorAmountReport(queryString);
    },
    fetchVisitorAmountReport(queryString) {
      this.$restClient.reports
        .amountOfVisitors({query: queryString})
        .then(response => {
          this.visitorAmount = response.data;
        })
        .catch(err => {
          console.log(err);
          this.$notify.notifyError({
            title: this.$t("failed")
          });
        });
    }
  }
};
</script>
